import React, { useMemo, useState } from 'react'
import { Box, Skeleton, SxProps } from '@mui/material'

type ImageContainerProps = {
	src: string
	width?: string
	sx?: SxProps
}

export default function ImageContainer({ src, width, sx }: ImageContainerProps) {
	const imgUrl = useMemo(() => `${process.env.PUBLIC_URL}${src}`, [src])
	const [isLoaded, setIsLoaded] = useState(false)
	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width, ...sx }}>
			{!isLoaded && (
				<Skeleton variant="rectangular" width="500px" height="500px" sx={{ backgroundColor: 'white' }} />
			)}
			<img
				src={imgUrl}
				alt="prop-ai-section-image"
				onLoad={() => setIsLoaded(true)}
				style={{
					opacity: isLoaded ? 1 : 0,
					transition: 'opacity 0.5s ease',
				}}
			/>
		</Box>
	)
}
